import { db } from '../lib/database'

export const storageService = {
  getStorageInfo() {
    let itemCount = 0
    return Promise.all([
      db.forms.count(),
      db.submissions.count(),
      db.outbox.count()
    ]).then(([forms, submissions, outbox]) => {
      itemCount = forms + submissions + outbox
      if ('storage' in navigator && 'estimate' in navigator.storage) {
        return navigator.storage.estimate().then(estimate => {
          const totalUsage = estimate.usage || 0
          const quota = estimate.quota || 0
          const usedMB = (totalUsage / (1024 * 1024)).toFixed(1)
          const quotaMB = (quota / (1024 * 1024)).toFixed(0)
          const usedPercentage = quota ? parseFloat(((totalUsage / quota) * 100).toFixed(2)) : 0
          return {
            usedBytes: totalUsage,
            usedMB: parseFloat(usedMB),
            quotaMB: parseFloat(quotaMB),
            usedPercentage,
            itemCount,
            availableMB: parseFloat((quotaMB - usedMB).toFixed(1))
          }
        })
      }
      return { usedBytes: 0, usedMB: 0, quotaMB: 0, usedPercentage: 0, itemCount, availableMB: 0 }
    }).catch(() => ({
      usedBytes: 0,
      usedMB: 0,
      quotaMB: 0,
      usedPercentage: 0,
      itemCount: 0,
      availableMB: 0
    }))
  },

  clearAllData() {
    const tables = [
      db.forms,
      db.submissions,
      db.form_questions,
      db.form_responses,
      db.outbox,
      db.settings,
      db.completedForms,
      db.userProfile,
      db.organization
    ]
    const clearPromises = tables.map(table => {
      if (table && table.clear) {
        return table.clear().then(() => true).catch(() => false)
      }
      return Promise.resolve(true)
    })
    return Promise.all(clearPromises).then(() => {
        db.close()
        return db.delete().then(() => db.open())
    })
  },

  clearAllBrowserStorage() {
    localStorage.clear()

    Object.keys(sessionStorage).forEach(key => {
      if (key !== 'splash_shown_this_session') {
        sessionStorage.removeItem(key)
      }
    })

    return this.clearAllData().then(() => {
      if ('caches' in window) {
        return caches.keys().then(cacheNames => 
          Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)))
        )
      }
    })
  }
}